// extracted by mini-css-extract-plugin
export default {"notificationMessageBlock":"NotificationMessage_notificationMessageBlock__p0WIT"};